import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PercentPipe } from './percent-pipe.pipe';



@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PercentPipe
  ],
  exports: [
    PercentPipe
  ]
})
export class PercentPipeModule { }
